import { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import CheckBox from "../../../../components/checkBox/CheckBox";
import StatusAlertModel from "../../../../components/statusAlertModel/StatusAlertModel";
import { ISubscribeOptionPackage } from "../../../../interfaces/protocolReportSubscriptionOptions";
import { ISuccessState } from "../../../../interfaces/successState";
import { subscribeProtocolReport } from "../../../../services/dashboard";
import styles from "./ConfirmSubscribe.module.scss";

interface IProps {
  setShowConfirmation: React.Dispatch<React.SetStateAction<boolean>>;
  selectedPackage: ISubscribeOptionPackage | undefined;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  serviceId: string;
}

const ConfirmSubscribe = (props: IProps) => {
  const { selectedPackage, setLoading, serviceId } = props;
  const [agreeToTnc, setAgreeToTnc] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<ISuccessState | undefined>();

  const subscribeHandler = () => {
    if (!selectedPackage) {
      return;
    }
    setLoading(true);
    subscribeProtocolReport({
      serviceId: serviceId,
      reporterPackage: selectedPackage.packageid,
    })
      .then(() => {
        setIsSuccess({
          isSuccess: true,
          message: "Successfully subscribed to detailed report",
        });
        setLoading(false);
      })
      .catch((err) => {
        setIsSuccess({ isSuccess: false, message: err.message });
        setLoading(false);
      });
  };

  return (
    <Row className="page-sub-container-v2">
      <Col>
        {selectedPackage && (
          <>
            <Row>
              <Col className={["text-center"].join(" ")}>
                <span className={styles.subscribePlan}>
                  Subscribe to usage report :{" "}
                  {selectedPackage.packagename.split(" ")[0]}
                </span>
              </Col>
            </Row>
            <Row>
              <Col className={["text-center mt-3", styles.price].join(" ")}>
                <span>{selectedPackage.packageinfo} + Tax</span>
              </Col>
            </Row>
            <Row>
              <Col className={["text-center mt-3", styles.tnc].join(" ")}>
                <CheckBox
                  checked={agreeToTnc}
                  onChange={(e) => {
                    setAgreeToTnc(e.target.checked);
                  }}
                  label={
                    <span className={styles.text}>
                      I Agree to the general{" "}
                      <Link to={"/"} className={styles.link}>
                        Terms and Conditions
                      </Link>
                    </span>
                  }
                />
              </Col>
            </Row>
            <Row className="justify-content-center mt-4">
              <Col className="col-auto">
                <Button
                  variant="primary"
                  onClick={() => props.setShowConfirmation(false)}
                >
                  Back
                </Button>
              </Col>
              <Col className="col-auto">
                <Button
                  variant="primary"
                  disabled={!agreeToTnc}
                  onClick={subscribeHandler}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Col>
      <StatusAlertModel isSuccess={isSuccess} setIsSuccess={setIsSuccess} />
    </Row>
  );
};

export default ConfirmSubscribe;
